//@flow
import * as Immutable from 'immutable';

import { VehicleCompartment } from 'common/models/flow/VehicleCompartment';
import type { VehicleCompartmentModelType } from 'common/models/flow/VehicleCompartment';

import { Volume } from './Volume';

import { Dimensions } from './Dimensions';

import { DataUtils } from 'common/utils/DataUtils';

import {
    validatable,
    softValidateAll,
    validateAll,
    validate
} from 'common/utils/ValidationUtil';

import I18nHelper from 'common/helpers/I18nHelper';
import NumberUtils from 'common/utils/NumberUtils';
const translationsNamespace = ['validations'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

@validatable
class InternalVehicleCompartment extends VehicleCompartment {
    static fromJS(
        json: VehicleCompartmentModelType
    ): InternalVehicleCompartment {
        const state: Object = Object.assign({}, json);
        state.volume = Volume.fromJS(state.volume);
        state.dimensions = Dimensions.fromJS(state.dimensions);
        return new this(Immutable.Map(state));
    }

    @softValidateAll
    hasValidationErrors(): boolean {
        return (
            this.volume.hasValidationErrors() ||
            this.dimensions.hasValidationErrors()
        );
    }

    @validateAll
    setAllValidationErrors(): this {
        return this.setVolume(
            this.volume.setAllValidationErrors()
        ).setDimensions(this.dimensions.setAllValidationErrors());
    }

    static defaultInit(): InternalVehicleCompartment {
        return InternalVehicleCompartment.fromJS({
            id: '',
            priority: null,
            optional: true,
            volume: {
                value: null,
                unit: ''
            },
            dimensions: {
                length: null,
                breadth: null,
                height: null,
                unit: null
            }
        });
    }

    defaultSanitize(): this {
        return this;
    }

    get volume(): Volume {
        return this._state.get('volume');
    }

    get dimensions(): Dimensions {
        return this._state.get('dimensions');
    }

    getCompartmentName(index: number): string {
        return `Compartment ${index + 1}`;
    }

    @validate
    setId(id: string): this {
        return super.setId(id);
    }

    validateId(): ?string {
        if (DataUtils.isEmpty(this.id)) {
            return nsTranslate('customFieldValidations.emptyValue');
        }
    }

    @validate
    setPriority(priority: number): this {
        return super.setPriority(priority);
    }

    validatePriority(): ?string {
        if (
            !NumberUtils.isInteger(this.priority) ||
            !NumberUtils.isPositiveNumber(this.priority)
        ) {
            return nsTranslate('customFieldValidations.notAPositiveInteger');
        }
    }
}

export { InternalVehicleCompartment as VehicleCompartment };
